<template>
  <div id="Banner">
    <div v-if="bannerDivider == 'field'">
      <img src="@/assets/images/DIVIDER-1.jpg" />
    </div>
    <div v-if="bannerDivider == 'fans'">
      <img src="@/assets/images/divider-2.jpg" />
    </div>
    <div v-if="bannerDivider == 'renew'">
      <img src="@/assets/images/divider-3.jpg" />
      <div class="rewew">
        <p>If you have any questions, please contact {{rep}}, your Rays Representative at {{repPhone}} or {{repEmail}}. Thank you again for being a vital part of this organization. We invite you to be a Season Member for 2021 and many seasons to come!</p>
        <div class="renewBtn" href="#">
          <a v-scroll-to="'#Renew'">Renew Now</a>
        </div>
      </div>
    </div>
    <div v-if="bannerDivider == 'crowd'">
      <img src="@/assets/images/divider-4.jpg" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: ["bannerDivider"],
  data() {
		return {
      rep: null,
      repEmail: null,
      repPhone: null
    }
  },
	created(){
    let userInfo = this.$store.state.global.userInfo;
    this.rep = userInfo.repName
    this.repEmail = userInfo.repEmail
    this.repPhone = userInfo.repPhone
  }
}
</script>

<style lang="scss" scoped>
#Banner {
  width: 100vw;
  margin: 100px 0;
  @media only screen and (max-width: $sm) {
    margin: 50px 0;
  }
  img {
    width: 100%;
  }
  .rewew {
    width: 100vw;
    padding: 70px 7%;
    display: flex;
    background-color: $dark-blue;
    @media only screen and (max-width: $md) {
      flex-direction: column;
    }
    p {
      font-family: 'UniversLTStd';
      color: #fff;
      font-size: 16px;
      width: 70%;
      text-align: justify;
      text-justify: inter-word;
      @media only screen and (max-width: $md) {
        width: 100%;
      }
    }
    .renewBtn {
      margin-top: 25px;
      width: 30%;
      text-align: center;
      @media only screen and (max-width: $md) {
        width: 100%;
      }
      a {
        font-family: 'UniversLTStd-Bold';
        font-size: 16px;
        color: #000;
        background-color: $yellow;
        border-radius: 25px;
        padding: 15px 40px;
        text-transform: uppercase;
        cursor: pointer;
        &:hover {
          text-decoration: none;
        }
      }
    }
  }
}
</style>